import { ErrorLabel, InputStates, InputWrapper, Label } from './styled';
import { UseFormRegisterReturn } from 'react-hook-form';
import { ChangeEventHandler, ReactElement } from 'react';

export interface PropsI {
  label?: string;
  errorMessage?: string;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  value?: string | number;
  registered?: UseFormRegisterReturn;
  icon?: ReactElement;
}

const Input = ({
  disabled,
  label,
  errorMessage,
  placeholder,
  registered,
  value,
  onChange,
  className,
  icon,
}: PropsI): JSX.Element => {
  return (
    <InputWrapper labelText={!!label} className={className}>
      {icon}
      {label && (
        <Label error={!!errorMessage} isDisabled={disabled}>
          {label}
        </Label>
      )}
      {registered ? (
        <InputStates
          {...registered}
          disabled={disabled}
          placeholder={placeholder}
          error={!!errorMessage}
          icon={!!icon}
        />
      ) : (
        <InputStates
          disabled={disabled}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          error={!!errorMessage}
          icon={!!icon}
        />
      )}
      {!!errorMessage && (
        <ErrorLabel error={!!errorMessage} labelText={!!label}>
          {errorMessage}
        </ErrorLabel>
      )}
    </InputWrapper>
  );
};

export default Input;
